import React, { useEffect, useState } from 'react';
import { Button, Center, Modal, Select, Text } from '@mantine/core';
import classes from './Beginner.module.css';
import useGetBonus from './useGetBonus';
import StepRow from './stepRow/StepRow';
import { currencies } from './currency';
import { useDisclosure } from '@mantine/hooks';

function BonusPage() {
    // Available currencies
    const { BeginnerQuery: { data, isPending, isError, isRefetching } } = useGetBonus();
    const [opened, { open, close }] = useDisclosure(false);
    // State for steps and global currency selection
    const [globalCurrency, setGlobalCurrency] = useState();
    const [steps, setSteps] = useState([
        {
            id: 1,
            name: "Step 1",
            fields: [
                { label: "Level", value: "", currency: "diamonds", fixed: true },
                { label: "Bonus Managers (optional)", value: "", currency: "eur" },
                { label: "Bonus Agents (optional)", value: "", currency: "eur" },
                { label: "Bonus Creators (optional)", value: "", currency: "eur" },
            ],
        },
    ]);

    useEffect(() => {
        if (data && data.length > 0) {
            const newSteps = data?.map((data, index) => ({
                id: data.id,
                name: data.name || `Step ${steps.length + 1}`,
                fields: [
                    { label: "Level", value: data.level || "", currency: "diamonds", fixed: true },
                    { label: "Bonus Managers (optional)", value: data.bonus_manager || "", currency: data.bonus_manager_currency || "eur" },
                    { label: "Bonus Agents (optional)", value: data.bonus_agent || "", currency: data.bonus_agent_currency || "eur" },
                    { label: "Bonus Creators (optional)", value: data.bonus_creator || "", currency: data.bonus_creator_currency || "eur" },
                ],
            }));

            setSteps(newSteps);
        }
    }, [data]); // Runs when `data` updates

    // Add a new step
    const addStep = () => {
        setSteps([
            ...steps,
            {
                id: steps.length + 1,
                name: `Step ${steps.length + 1}`,
                fields: [
                    { label: "Level", value: "", currency: "diamonds", fixed: true },
                    { label: "Bonus Managers (optional)", value: "", currency: globalCurrency ?? "eur" },
                    { label: "Bonus Agents (optional)", value: "", currency: globalCurrency ?? "eur" },
                    { label: "Bonus Creators (optional)", value: "", currency: globalCurrency ?? "eur" },
                ],
            },
        ]);
    };



    const handleGlobalCurrencyChange = (newCurrency) => {
        console.log({ newCurrency });


        setGlobalCurrency(newCurrency);



        // setSteps(
        //     prev => (
        //         {
        //             ...prev,
        //             fields: steps.fields.map((field, index) =>
        //                 !field.fixed ? { ...field, currency: newCurrency } : field
        //             ),
        //         }
        //     )
        // );
    };



    // Handle global currency change (updates all fields except "Level")





    if (!data && !isPending) {
        return <div>No data available</div>;
    }


    const removeUnusedSteps = (index) => {
        setSteps((prevSteps) => {
            const updatedSteps = [...prevSteps]; // Create a copy
            updatedSteps.splice(index, 1); // Remove the step at the given index
            return updatedSteps; // Update state
        });
    }

    return (
        <div>
            <div className={classes.wrapper}>
                <div>
                    <h1>Beginners Bonus</h1>
                    {/* <Button
                        //  mt="md"
                        variant="gradient"
                        radius="200px"
                        gradient={{ from: "#44FFFA", to: "#FF4267", deg: 90 }}
                    >
                        Save Changes
                    </Button> */}
                </div>

                {/* Global Currency Selector */}
                <Select
                    value={globalCurrency}
                    onChange={handleGlobalCurrencyChange}
                    data={currencies} // Prevent diamonds from being set globally
                    style={{ width: "150px" }}
                    searchable
                />
            </div>

            <Button variant="outline" onClick={addStep} style={{ marginBottom: "20px" }}>
                + Add Step
            </Button>
            &nbsp;
            <Button variant="outline" color="red" onClick={open} style={{ marginBottom: "20px" }} >
                Return
            </Button>

            {steps?.map((step, index) => (
                <StepRow index={index} key={step?.id + ''} stepData={step} removeUnusedSteps={removeUnusedSteps}

                    globalCurrency={globalCurrency}
                />
            ))}

            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to leave this page?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => window.history.back()}
                    >Confirm</Button>
                </Center>

            </Modal >

        </div>
    );
}

export default BonusPage;


